import { defineComponent as _defineComponent } from 'vue'
import router from '@/router';
import { onMounted } from 'vue';
import { defineMessages } from '@/lib/i18n';


export default /*#__PURE__*/_defineComponent({
  __name: 'UnregisterPage',
  setup(__props) {

const m = defineMessages({
  thankYouMessage:
    'アクセスいただきありがとうございます。10秒後にトップページに移動します。',
});

onMounted(async () => {
  // 初回のみ実行
  if (!localStorage.getItem('hasInitialReload')) {
    // Service Workerの登録解除
    const registrations = await navigator.serviceWorker.getRegistrations();
    for (const registration of registrations) {
      registration.unregister();
    }

    // キャッシュのクリア
    if (window.caches) {
      const cacheNames = await window.caches.keys();
      for (const cacheName of cacheNames) {
        await caches.delete(cacheName);
      }
    }

    // スーパーリロード
    window.location.reload(true);

    // 初回実行フラグを設定
    localStorage.setItem('hasInitialReload', 'true');
  } else {
    // 10秒後にトップページへリダイレクト
    setTimeout(() => {
      // フラグの削除
      localStorage.removeItem('hasInitialReload');
      router.push({ name: 'top' });
    }, 10000);
  }
});

return { __sfc: true,m }
}

})